/**
 * Toolbar.js
 * Bottom toolbar with tool tray
 *
 * @module  Toolbar
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

import Container from 'components/flexbox/Container';
import Block from 'components/flexbox/Block';
import Paper from 'components/paper/Paper';

export default React.createClass({

	displayName: 'Toolbar',

	propTypes: {
		fixed: React.PropTypes.oneOf(['bottom', 'top'])
	},

	getDefaultProps() {

		return {
			fixed: 'bottom',
		};
	},

	getInitialState() {
		return {
			tray_open: false,
			tray_component: '',
			tray_height: 300
		}
	},

	render() {

		let {
			fixed,
			children
		} = this.props;

		let toolbarClasses = ClassNames({
			'lui-toolbar': true,
			'lui-fixed-bottom': fixed === 'bottom',
			'lui-fixed-top': fixed === 'top'
		});

		let trayStyles = {
			height: this.state.tray_open ? this.state.tray_height + 'px' : 0 + 'px'
		};

		let tooltrayClasses = ClassNames({
			'lui-tooltray': true,
			'lui-tooltray-top': fixed === 'top',
			'lui-tooltray-bottom': fixed === 'bottom',
			'lui-tooltray-open': this.state.tray_open
		});

		let spacer = fixed ? (
			<div>
				<div className="lui-toolbar lui-spacer" />
				<div style={ trayStyles } />
			</div>
		) : '';

		return (
			<Container>
				<Block width={1}>
					<Paper depth={1} className={tooltrayClasses}>
						<div style={trayStyles}>
							{this.state.tray_component}
						</div>
					</Paper>
					<Paper depth={1}>
						<div className={toolbarClasses}>
							{children}
						</div>
					</Paper>
					{spacer}
				</Block>
			</Container>
		);
	},

	getHeight() {
		return React.findDOMNode(this).height;
	},

	setToolTray(component, height) {
		this.setState({ tray_component: component, tray_height: height });
	},

	openToolTray() {
		this.setState({ tray_open: true });
	},

	closeToolTray() {
		this.setState({ tray_open: false });
	},

	toggleToolTray() {
		this.setState({ tray_open: !this.state.tray_open });
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/toolbar/Toolbar.js
 **/